// 金額先按十進位轉分再四捨五入，顯示和提交使用同一數值。
export function roundMoney(value: string | number): number {
  const text = String(value);
  if (!/^\d+(\.\d+)?$/.test(text)) return 0;
  const [whole, fraction = ""] = text.split(".");
  const cents =
    Number(whole) * 100 +
    Number((fraction + "00").slice(0, 2)) +
    (Number(fraction[2] || 0) >= 5 ? 1 : 0);
  return Number.isSafeInteger(cents) && cents > 0 && cents <= 999999999999
    ? cents / 100
    : 0;
}
// MySQL decimal 可能以字串回傳，統一轉成數值後顯示兩位小數。
export const formatMoney = (value?: number | string | null) =>
  Number(value || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
